<template>
  <div>
    <template v-for="(doc_, p1) in doc">
      <v-dialog v-model="show_modal" persistent max-width="900px">
        <v-card>
          <v-card-title class="headline">Destinatarios para firmar</v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="validForm" @submit.prevent="enviar_correos" lazy-validation>
              <template v-for="(destinatario_, index) in array_destinatarios">
                <v-row>
                  <v-col cols="12" md="3" >
                     
                    <vue-bootstrap-typeahead
                      v-model="destinatario_.correo" 
                      :data="correo_firmantes" 
                      placeholder="Correo electrónico"
                      :serializer="getItemText" minMatchingChars = 1                
                    />
                    
                    
                    <!-- Filter by input text to only show the matching results -->
                    
                  </v-col>

                  <v-col cols="12" md="1"  v-if="destinatario_.existe">
                    <v-icon>
                      mdi-check-outline
                    </v-icon>
                  </v-col>
                  
                  <v-col cols="12" md="1"  v-if="!destinatario_.existe">
                    <v-btn small color="danger" @click="validarUsuario(destinatario_)">
                      <v-icon >
                        mdi-circle-edit-outline
                      </v-icon>
                    </v-btn>
                  </v-col>

                  <v-col cols="12" md="2" >
                    <v-checkbox 
                      v-if="destinatario_.existe && doc_.usuario_es_duenio && !doc_.bloqueado"
                      v-model="destinatario_.firmar" :label="`¿solicitar firma?`">
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2" >
                    <v-checkbox 
                      v-if="destinatario_.firmar"
                      v-model="destinatario_.fecha" :label="`¿fecha limite?`">
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="4" >
                    <v-menu
                      :ref="createRef(index)"
                      v-if="destinatario_.fecha"
                      v-model="destinatario_.menu" 
                      :close-on-content-click="false"
                      :return-value.sync="destinatario_.fecha_limite"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="destinatario_.fecha_limite" 
                          label="Fecha limite de firma"
                          prepend-icon="event"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="destinatario_.fecha_limite" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="destinatario_.menu = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="setRef(index, destinatario_)">Guardar</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" md="1" >
                    <v-btn small color="danger" v-if="index > 0" @click="eliminar_destinatario(index)" style="margin-top: 20px;">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="cerrar_form"> Cerrar </v-btn>
            <v-btn  class="pull-left" :disabled="loading" color="info" @click="nuevo_destinatario"> Nuevo destinatario </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :loading="loading"
              :disabled="loading" 
              color="primary" 
              @click="enviar_correos(doc_, p1)" 
              type="submit"> Enviar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>
<script>
  $("ready").children('vue-bootstrap-typeahead').addClass('ListaCorreos')
  import axios from "axios";
  import Autocomplete from 'vuejs-auto-complete';
  import VueSimpleSuggest from 'vue-simple-suggest';
  import 'vue-simple-suggest/dist/styles.css' // Optional CSS
  import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

  export default {
      components: {Autocomplete,VueSimpleSuggest,VueBootstrapTypeahead},

  		props: ['show_modal', 'doc'],
  		data: function() {
  		  return {
          loading: null,
  		  	documentos_firmados: [],
          correo_firmantes: [],
  		  	array_destinatarios: [{ "correo": "", "existe" : null, "firmar": false, "fecha": false, 'fecha_limite': new Date().toISOString().substr(0, 10), 'menu': false, 'ref': '' }],
  	      validForm: true,
  	      emailRules: [
  	        v => !!v || 'Campo requerido',
  	        v => /.+@.+\..+/.test(v) || 'Debe ser un correo valido',
  	      ],
  		  };
  		},
    	computed: {
    	},
    	mounted() {
          this.ver_agrupador();
    	},
    	methods: {
        getItemText(item) {
            return item.correo;
        },
        seleccionarDestinatario(item,destinatario){
          console.log("ITEM: ",item)
          console.log("DESTINATARIO: ",destinatario);
        },
            ver_agrupador() {
          let firmantes = axios.get('AgrupadorFirmante/listar?AgrupadorId='+ this.$store.state.user.agrupador_id, { 'headers': this.$store.state.user.headers })
  				return firmantes.then((callback) => 
  				{
  				  if (callback.status == 200) {
              this.correo_firmantes = callback.data;
  				  } 
  				}).catch((error) => {
  				  console.log("ERROR: ",error);
  				});
        },
  	  	nuevo_destinatario(){
  	  		this.array_destinatarios.push({ "correo": "", "existe" : null, "firmar": false, "fecha": false, 'fecha_limite': new Date().toISOString().substr(0, 10), 'menu': false, 'ref': '' });
  	  	},
  	  	eliminar_destinatario(index){
  	  		this.array_destinatarios.splice(index, 1);
  	  	},
  	  	cerrar_form(){
  	  		this.array_destinatarios=[{ "correo": "", "existe" : null, "firmar": false, "fecha": false, 'fecha_limite': new Date().toISOString().substr(0, 10), 'menu': false, 'ref': '' }];
          this.$emit('childToParent', {'modal': false, 'data': [] });
  	  	},
  	  	enviar_correos(doc, index)
  	  	{
  	  		var _thisEC = this;
  	  		if(this.$refs.form.length == 1){
  	  			index = 0;
  	  		}
  
  	  		if (this.$refs.form[index].validate())
  	  		{
            this.loading = true;
  					let paqueteData = { 
  				    "to":"",
  				    "from":"noreply@prisma.gt",
  				    "subject": doc.nombre_archivo,
  				    "plainTextContent": "Adjunto documento: " + doc.nombre_archivo,
  				    "htmlContent":"<p>Estimado usuario: <br /><br /> Adjunto copia del documento <strong>" +doc.nombre_archivo+"</strong>, enviado por: "+this.$store.state.user.email+"</p><p><small>Correo enviado por el sistema Infile Sign.</small></p>.",
  				    "DocumentoId":doc.id,
  						"lista_destinatarios": this.array_destinatarios
  					}
  	        let postEmail = axios.post('Mail', paqueteData,  { 'headers': this.$store.state.user.headers })
  	        return postEmail.then((callback) => 
  	        {
  	        	if(callback.status == 200){
                this.$emit('childToParent', {'modal': false, 'data': this.array_destinatarios });
                this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Enviado correctamente' });
  	        		this.array_destinatarios=[{ "correo": "", "existe" : null, "firmar": false, "fecha": false, 'fecha_limite': null, 'menu': false, 'ref': '' }];
  	        	} else {
                this.$emit('childToParent', {'modal': true, 'data': [] });
  	        	}
              this.loading = false;
  	        }).catch((error) => {
  	        	console.log(error.response.data);
              this.$emit('childToParent', {'modal': true, 'data': [] });
  	        });
  	  		} else {
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Llenar todos los campos.' });
  	  		}
  	  	},
  	  	validarUsuario(user_){
  				let getUser = axios.get('InfoUsuario/existe?correo='+user_.correo, { 'headers': this.$store.state.user.headers })
  				return getUser.then((callback) => 
  				{
  				  if (callback.status == 200) {
  						user_.existe = true;
  				  } 
  				}).catch((error) => {
  				  user_.existe = false;
  				  user_.firmar = false;
  				});
  	  	},
        createRef(index) {
          return "menu-"+index;
        },
        setRef(index, item){
          this.$refs['menu-'+ index][0].save(item.fecha_limite);
        },
        parseDate(date) {
          if (!date) return null
          const [year, month, day] = date.split('-')
          return `${day}-${month}-${year}`
        },
    	},
  };
</script>